import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

const field = "w-full border border-border bg-background px-4 py-3 font-body text-sm focus:outline-none focus:border-foreground transition-colors";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (admin && admin.role === "admin") navigate("/admin"); }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, password); toast.success("Welcome back"); navigate("/admin"); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[hsl(var(--secondary))] flex items-center justify-center px-6 grain">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <img src="/logo.png?v=2" alt="Navrang Udaipur" className="w-24 h-24 rounded-full object-cover mx-auto mb-4" />
          <p className="overline text-[hsl(var(--accent))] mt-1">Admin Portal</p>
        </div>
        <form onSubmit={submit} className="bg-background p-8 md:p-10 space-y-4" data-testid="admin-login-form">
          <h1 className="font-display text-3xl mb-4">Sign in</h1>
          <input className={field} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          <input className={field} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-[hsl(var(--primary))] text-white px-8 py-4 font-body text-sm hover:bg-[hsl(var(--secondary))] transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
